import React from 'react';
import CardLayout from '../../../../../../../shared/components/card/CardLayout';
import { Button, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IBrandCollaborations } from '../../../../../../../model/shared/ICollaboration';
import { formatDate, sanitizeUrl } from '../../../../../../../shared/functions/Functions';
import { KPICard } from '../../../../../../../shared/components/card/KPICard';

interface ExternalProfileBrandDetailProps {
    brand: IBrandCollaborations;
    isInfluencer: boolean;
}
const ExternalProfileBrandDetail = ({ brand, isInfluencer }: ExternalProfileBrandDetailProps) => {
    const { t } = useTranslation();
    const handleClick = () => {
        window.open(sanitizeUrl(brand.domain) ?? '', '_blank', 'noopener,noreferrer');
    };

    return (
        <>
            <CardLayout classCard="mb-3">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <img
                            width={50}
                            className="rounded-circle object-fit-contain shadow-sm"
                            src={brand?.logoUrl}
                            alt={brand?.name}
                        />
                        <h6 className="mb-0 pl-2">{brand?.name}</h6>
                    </div>
                    {brand?.domain && (
                        <Button onClick={handleClick} variant="outline-primary">
                            {t('brand.campaign.book.external_search.website_link')}
                        </Button>
                    )}
                </div>
                <Row className="mt-3 ">
                    <Col className="mt-lg-0 mt-3" lg={3} xs={6}>
                        <KPICard
                            value={brand?.totalCollaboration ?? 0}
                            text={t('brand.campaign.book.external_search.collaborations')}
                            img={'/icons/kpi/img-collaborations.svg'}
                        />
                    </Col>
                    {!isInfluencer && (
                        <Col className="mt-lg-0 mt-3" lg={3} xs={6}>
                            <KPICard
                                value={brand?.category ?? '-'}
                                text={t('brand.campaign.book.external_search.category')}
                                img={'/icons/kpi/img-category.svg'}
                            />
                        </Col>
                    )}
                    <Col className="mt-lg-0 mt-3" lg={3} xs={6}>
                        <KPICard
                            value={formatDate(brand?.firstCollaborationDate)}
                            text={t('brand.campaign.book.external_search.first_collaboration')}
                            img={'/icons/kpi/img-first-collab.svg'}
                        />
                    </Col>
                    <Col className="mt-lg-0 mt-3" lg={3} xs={6}>
                        <KPICard
                            value={formatDate(brand?.lastCollaborationDate)}
                            text={t('brand.campaign.book.external_search.last_collaboration')}
                            img={'/icons/kpi/img-last-collab.svg'}
                        />
                    </Col>
                </Row>
            </CardLayout>
        </>
    );
};

export default ExternalProfileBrandDetail;
